/**
 * ポイント適用上限
 */
export class ApplicablePoint {
  static readonly empty: ApplicablePoint = new ApplicablePoint(0)

  private readonly limit: number

  constructor(limit: number) {
    if (limit < 0) {
      throw new Error(`applicable point should be > 0, but actual is ${limit}`)
    }

    this.limit = Math.floor(limit) // 整数値のみ許容
  }

  contain(point: number| ''): boolean {
    if (point === '') {
      return false
    }

    return 0 <= point && point <= this.limit
  }

  toNumber(): number {
    return this.limit
  }

  get exists(): boolean {
    return this.limit > 0
  }
}
